<template>
  <footer class="footer">
    <p>&copy; 2025 Employee Directory</p>
  </footer>
</template>

<style scoped>
.footer {
  margin-top: 3rem;
  text-align: center;
  padding: 1rem;
  background: #f1f1f1;
}
</style>
